export default __webpack_public_path__ + "locales/pl/Settings.json?hash=88d438a2d99eb37785efd6ac7ae24038";